import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StarIcon from '../../../images/other/star.inline.svg';

import './Votes.scss';

const Votes = ({ votes, votesRating, setVotesRating, text, thanks }) => {
  const [hoverStar, setHoverStar] = useState(0);
  return (
    <>
      <div className='votes' onMouseLeave={() => setHoverStar(0)}>
        {votes.map((vote) => {
          let voteClass = null;

          if (+votesRating >= vote) {
            voteClass = 'rating';
          } else if (vote <= hoverStar && !votesRating) {
            voteClass = 'hover';
          } else {
            voteClass = 'not-hover';
          }

          return (
            <StarIcon
              key={vote}
              onClick={votesRating !== 0 ? () => { } :
                () => {
                  setVotesRating(vote);
                  alert(thanks);
                }}
              onMouseOver={() => setHoverStar(vote)}
              className={`vote-star vote-star-${voteClass}`}
            />
          );
        })}
      </div>
      <span className='vote-text'>&nbsp;&nbsp;{text}</span>
    </>
  );
};

export default Votes;

Votes.propTypes = {
  votes: PropTypes.array,
  votesRating: PropTypes.number,
  setVotesRating: PropTypes.func,
  text: PropTypes.string,
  thanks: PropTypes.string,
};


